<!--
 * @Description: 按班级添加
 * @Author: xiawenlong
 * @Date: 2021-04-22 10:06:14
 * @LastEditors: xiawenlong
 * @LastEditTime: 2021-11-25 08:36:48
-->
<template>
  <el-dialog
    top="5vh"
    :close-on-click-modal="false"
    class="add-student-by-class"
    :visible.sync="dialogVisible"
  >
    <div class="title">按已开班级选择员工</div>
    <div class="close-icon" @click="dialogVisible = false">
      <i class="el-icon-close"></i>
    </div>
    <div class="body">
      <div class="content">
        <div class="left">
          <p>已选总人数：{{ selectStudent.length }}人</p>
          <el-scrollbar>
            <ul class="classList">
              <li
                v-for="item in classList"
                :key="item.classId"
                :class="[{ active: currentClassId == item.classId }]"
                :title="item.className"
                @click="selectClass(item)"
              >
                {{ item.className }}
              </li>
            </ul>
          </el-scrollbar>
        </div>
        <table-list
          ref="studentByClassTable"
          :loading="loading"
          :data="studentList"
          :search-form="searchForm(this)"
          :columns="columns(this)"
          :pager="pager"
          :options="{
            selection: true,
            reserveSelection: true,
            rowKey: 'studentId',
            selectable: selectEvent,
          }"
          @search="onSearch"
          @selectionChange="handleSelectionChange"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        ></table-list>
      </div>
      <div class="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button :loading="submitLoading" type="primary" @click="submit">确定</el-button>
      </div>
    </div>
  </el-dialog>
</template>
<script>
const searchForm = () => [
  {
    label: '姓名进行搜索',
    prop: 'keyword',
    width: 150,
  },
]
// 表格列配置
const columns = () => [
  {
    prop: 'studentName',
    label: '姓名',
    minWidth: 150,
  },
  {
    prop: 'cardNo',
    label: '证件号',
    minWidth: 250,
  },
]
import TableList from '@/components/TableList'
import { studentsByClass, studentsClasses, studentsAdd } from '@/api/class'
import to from 'await-to'
export default {
  name: 'AddStudentByClass',
  components: { TableList },
  data() {
    return {
      searchForm,
      columns,
      dialogVisible: false,
      loading: false,
      studentList: [],
      classList: [],
      selectStudent: [],
      currentClassId: '',
      pager: {
        total: 0,
        size: 10,
        current: 1,
      },
      submitLoading: false,
      queryParams: {},
    }
  },
  methods: {
    show() {
      this.dialogVisible = true
      this.pager.current = 1
      this.getClassList()
      this.$nextTick(() => {
        this.$refs.studentByClassTable.$refs.tableList.clearSelection()
      })
    },
    async getStudentList() {
      if (this.loading) return
      const { current, size } = this.pager
      const { classId } = this.$route.params
      const { currentClassId } = this
      this.loading = true
      const [res, err] = await to(
        studentsByClass({ classId, currentClassId, current, size, ...this.queryParams }),
      )
      this.loading = false
      if (err) return this.$message.warning(err.msg)
      this.studentList = res.data.list
      this.pager.total = res.data.total
    },
    async getClassList() {
      const { classId } = this.$route.params
      const [res, err] = await to(studentsClasses({ classId }))
      if (err) return this.$message.warning(err.msg)
      this.classList = res.data
      this.currentClassId = res.data[0].classId
      this.getStudentList()
    },
    selectClass(item) {
      this.currentClassId = item.classId
      this.pager.current = 1
      this.getStudentList()
    },
    async submit() {
      if (this.submitLoading) return
      if (!this.selectStudent.length) return this.$message.warning('请先选择员工')
      const { classId } = this.$route.params
      this.submitLoading = true
      const [, err] = await to(
        studentsAdd({ classId, students: this.selectStudent.map(item => item.studentId) }),
      )
      this.submitLoading = false
      if (err) return this.$message.warning(err.msg)
      this.$message.success('添加成功')
      this.dialogVisible = false
      this.$emit('success')
    },
    // 查询按钮
    onSearch(queryParams) {
      this.pager.current = 1
      this.queryParams = queryParams
      this.getStudentList()
    },
    // 多选
    handleSelectionChange(val) {
      this.selectStudent = val
    },
    // 分页
    handleSizeChange(size) {
      this.pager.current = 1
      this.pager.size = size
      this.getStudentList()
    },
    handleCurrentChange(current) {
      this.pager.current = current
      this.getStudentList()
    },
    selectEvent(row) {
      return !row.flag
    },
  },
}
</script>
<style lang="scss" scoped>
.add-student-by-class {
  ::v-deep.el-dialog {
    position: relative;
    width: 960px;
    background: #ffffff;
    border-radius: 0;
    color: #4d4e5d;
    .close-icon {
      z-index: 99;
      cursor: pointer;
      position: absolute;
      right: 24px;
      top: 14px;
      font-size: 25px;
      font-weight: bold;
      color: #8c8c8c;
    }
    .el-dialog__header {
      display: none;
    }
    .el-tabs__header {
      margin-bottom: 26px;
      padding-top: 23px;
    }
    .el-dialog__body {
      padding: 0;
    }
    .body {
      box-sizing: border-box;
      padding: 0 20px 20px 20px;
    }
    .title {
      height: 62px;
      line-height: 62px;
      border-bottom: 1px solid #c9c9c9;
      padding-left: 30px;
      font-size: 18px;
    }
    .content {
      display: flex;
      .left {
        padding-top: 20px;
        p {
          text-align: center;
          font-size: 14px;
          font-weight: bold;
          margin-bottom: 10px;
          line-height: 40px;
        }
        .el-scrollbar {
          height: 520px;
        }
        .el-scrollbar__wrap {
          overflow: scroll;
          overflow-x: hidden;
          width: 110%;
          height: 100%;
        }
        .classList {
          height: 520px;
          width: 150px;
          padding-right: 10px;
          padding-top: 20px;
          li {
            box-sizing: border-box;
            cursor: pointer;
            line-height: 50px;
            width: 150px;
            padding: 0 20px;
            margin-bottom: 5px;
            border-radius: 4px;
            @extend %one-line-text;
            &:hover {
              background-color: #fff2eb;
            }
            &.active {
              background-color: #ff7b33;
              color: #fff;
            }
          }
        }
      }
      .table-list {
        flex: 1;
        margin-left: 10px;
        .el-checkbox__input.is-disabled .el-checkbox__inner {
          display: none;
        }
        .el-table th > .cell {
          padding-left: 14px;
        }
      }
    }
    .footer {
      padding-top: 20px;
      text-align: right;
    }
  }
}
</style>
